import { applyMiddleware, compose, createStore, Store } from 'redux'
import thunkMiddleware from 'redux-thunk'

import { ClockState } from './ClockReducer'
import { JackpotPrizeHistoryState } from './jackpotSitAndGo/jackpotPrizeHistoryReducer'
import { JackpotSitAndGoEntriesState } from './jackpotSitAndGo/JackpotSitAndGoEntriesReducer'
import { PlayerItemsState } from './player-items/PlayerItemsReducer'
import { HandHistoryState } from './player/HandHistoryReducer'
import {
	appReducer,
	CashoutState,
	GameServerState,
	PhoneVerificationState,
	PlayerState,
	PurchaseState,
	UserState,
} from './Reducers'
import { SddStatusState } from './cashier/SddStatusReducer'
import { ReduxAction } from './ReduxUtils'
import { CasinoGameState } from './casino-games/CasinoGamesReducer'
import { RecentlyPlayedState } from './cashier/RecentlyPlayedReducer'
import { TriggerState } from './triggers/TriggerReducer'
import { SocialLiveCasinoLiveStats } from './social-live-casino/LiveStatsState'
import { BrazeState } from './braze/BrazeReducer'
import { ViewsState } from './views/Views'
import type { PlayerGamesState } from './player-games/PlayerGameState'
import { JsngGameState } from './jsng-games/JsngGamesReducer'

export interface ApplicationState {
    braze: BrazeState,
	player?: PlayerState
	user?: UserState
	history?: HandHistoryState
	jsngJackpots?: JackpotPrizeHistoryState
	jsngEntries?: JackpotSitAndGoEntriesState
	clock?: ClockState
	cashout?: CashoutState
	purchase?: PurchaseState
	sddStatus?: SddStatusState
	phoneVerification?: PhoneVerificationState
	playerItems: PlayerItemsState
	gameServer: GameServerState
	casinoGames: CasinoGameState
	jsngGames: JsngGameState
	recentlyPlayedGameItems: RecentlyPlayedState
	triggers: TriggerState
	socialLiveCasinoStats: SocialLiveCasinoLiveStats
	views: ViewsState
	playerGames?: PlayerGamesState
}

let composeFn
if (process.env.POK_STAGE === 'prod') {
	composeFn = compose
} else {
	composeFn = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
}

let store: Store<ApplicationState> = createStore<ApplicationState>(
	appReducer,
	composeFn(applyMiddleware(thunkMiddleware)),
)

export function getStore(): Store<ApplicationState> {
	return store
}

export function resetStore() {
	store = createStore<ApplicationState>(appReducer, applyMiddleware(thunkMiddleware))
}

export function dispatch<T>(action: ReduxAction<T> | any) {
	getStore().dispatch(action as any)
}
